import type ImportedConfig from "../public/config.json";
import type { AgentConfig } from "@recordsure/unity-agent";

export type Config = typeof ImportedConfig.default & { agent?: AgentConfig };

export let config: Config;

export const loadConfig = async () => {
  const res = await fetch("/config.json");
  if (!res.ok) throw new Error("Failed to load config");

  const json = Object.freeze((await res.json()) as Record<string, Config>);
  config = Object.freeze({ ...json.default, ...json[window.location.host] });
};
